// extracted by mini-css-extract-plugin
export default {"link":"styles-module__link--NpbiP","header":"styles-module__header--r3Nv4","category":"styles-module__category--VutQs","column_wrapper":"styles-module__column_wrapper--XqdsL"};